export default __webpack_public_path__ + "static/dropdownAppStore-e1b9e2c4da57c98c37063b2c9b9afb6c.png";